var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9912 3.01009L3.39919 7.56309L7.59419 9.99109L11.2932 6.29109C11.4808 6.10358 11.7353 5.99829 12.0005 5.99839C12.2658 5.99848 12.5202 6.10395 12.7077 6.29159C12.8952 6.47923 13.0005 6.73367 13.0004 6.99894C13.0003 7.26421 12.8948 7.51858 12.7072 7.70609L9.00719 11.4061L11.4372 15.6001L15.9912 3.01009ZM16.3142 0.76609C17.5092 0.33309 18.6672 1.49109 18.2342 2.68609L12.9522 17.2911C12.5182 18.4891 10.8822 18.6351 10.2432 17.5321L7.02619 11.9741L1.46819 8.75709C0.365189 8.11809 0.511189 6.48209 1.70919 6.04809L16.3142 0.76609Z",
    fill: "#32BC69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendGreen);
export default __webpack_public_path__ + "static/media/send-green.bf2ce369a483b7c7f70b8599b3e3a371.svg";
export { ForwardRef as ReactComponent };